import React from 'react';
import { MenuItem, Select, SelectProps, FormControl, InputLabel } from '@mui/material';

type Props = SelectProps & {
  onValueChange?: (nextValue: any) => void;
  options: { label: string; value: string }[];
};

export const FormSelect = ({ label, options, onValueChange, variant = 'outlined', ...other }: Props) => {
  return (
    <FormControl size="small" variant={variant} fullWidth>
      <InputLabel id="formSelectLabel" variant={variant}>
        {label}
      </InputLabel>

      <Select
        fullWidth
        size="small"
        label={label}
        variant={variant}
        labelId="formSelectLabel"
        onChange={(event, child) => {
          if (onValueChange) onValueChange(event.target.value as string);
          other?.onChange?.(event, child);
        }}
        {...other}
      >
        {options.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
